import { buildNovoAutomacaoFormSteps } from './automacaoTourSteps'

const LISTA_READY_SELECTOR = '[data-tour="automacao-novo"]'
const FORM_READY_SELECTOR = '[data-tour="automacao-form-root"]'
const FORM_START_INDEX = 2
const NOVO_STEP_INDEX = 1

const openNovoAutomacao = (tourManager) => {
    tourManager.navigateAndWait('/automacao/novo', FORM_READY_SELECTOR, FORM_START_INDEX, 'novo-automacao')
        .then(() => tourManager.moveTo(FORM_START_INDEX))
        .catch(() => {})
}

const bindNovoAutomacaoClick = (element, tourManager) => {
    const button = element?.matches?.('[data-tour="automacao-novo"]')
        ? element
        : document.querySelector('[data-tour="automacao-novo"]')

    if (!button || button._hdvNovoAutomacaoClick) return

    const onClick = (event) => {
        event.preventDefault()
        event.stopPropagation()
        event.stopImmediatePropagation?.()
        openNovoAutomacao(tourManager)
    }

    button.addEventListener('click', onClick, true)
    button._hdvNovoAutomacaoClick = onClick
}

const unbindNovoAutomacaoClick = (element) => {
    const button = element?.matches?.('[data-tour="automacao-novo"]')
        ? element
        : document.querySelector('[data-tour="automacao-novo"]')

    if (!button?._hdvNovoAutomacaoClick) return

    button.removeEventListener('click', button._hdvNovoAutomacaoClick, true)
    delete button._hdvNovoAutomacaoClick
}

const buildNovoAutomacaoTourSteps = (tourManager) => [
    {
        popover: {
            title: 'Automações',
            description: 'Uma automação faz a plataforma executar uma ação automaticamente quando algo acontece. Por exemplo, ela pode ligar ou desligar um equipamento, enviar um comando ou gerar um alerta.<br><br>Neste guia, você verá como criar uma automação e configurar cada uma de suas etapas.<br><br>Para criar uma automação, é necessário ter pelo menos um <a href="/monitorado/" class="hdv-tour-start-link">Monitorado</a> ativo no sistema.',
            side: 'over',
            align: 'center',
        },
    },
    {
        element: '[data-tour="automacao-novo"]',
        ensureReady: () => tourManager.waitForElement(LISTA_READY_SELECTOR),
        popover: {
            title: 'Nova automação',
            description: 'Clique em Próximo para abrir o cadastro de uma nova automação.',
            side: 'bottom',
            align: 'start',
            onNextClick: () => openNovoAutomacao(tourManager),
        },
        onHighlighted: (element) => bindNovoAutomacaoClick(element, tourManager),
        onDeselected: (element) => unbindNovoAutomacaoClick(element),
    },
    ...buildNovoAutomacaoFormSteps(tourManager, { indiceNovoStep: NOVO_STEP_INDEX }),
]

export default buildNovoAutomacaoTourSteps
